import React from 'react';
import { Handle, Position } from 'reactflow';
import * as Icons from 'lucide-react';

const CustomNode = ({ data, selected }) => {
  const IconComponent = Icons[data.icon] || Icons.Circle;

  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 bg-white shadow-md min-w-[180px] transition-all ${
        selected ? 'border-indigo-500 shadow-lg' : 'border-gray-300'
      }`}
      style={{
        borderColor: selected ? data.color : undefined,
      }}
    >
      <Handle type="target" position={Position.Top} className="w-3 h-3" />

      <div className="flex items-center gap-2 mb-1">
        <div
          className="p-1.5 rounded-md"
          style={{ backgroundColor: `${data.color}20` }}
        >
          <IconComponent className="w-4 h-4" style={{ color: data.color }} />
        </div>
        <div className="flex-1">
          <div className="font-semibold text-sm text-gray-900">{data.label}</div>
          {data.config?.name && (
            <div className="text-xs text-gray-500 truncate">{data.config.name}</div>
          )}
        </div>
      </div>

      {data.config && Object.keys(data.config).length > 0 && (
        <div className="mt-2 pt-2 border-t border-gray-200">
          <div className="text-xs text-gray-600 space-y-0.5">
            {data.config.template && <div className="flex items-center gap-1 truncate"><Icons.FileText className="h-3 w-3 flex-shrink-0" /> {data.config.template}</div>}
            {data.config.analysisType && <div className="flex items-center gap-1 truncate"><Icons.Search className="h-3 w-3 flex-shrink-0" /> {data.config.analysisType}</div>}
            {data.config.domain && <div className="flex items-center gap-1 truncate"><Icons.Scale className="h-3 w-3 flex-shrink-0" /> {data.config.domain}</div>}
          </div>
        </div>
      )}

      <Handle type="source" position={Position.Bottom} className="w-3 h-3" />
    </div>
  );
};

export default CustomNode;
